import React from "react";

export default function DataTable({
  title,
  columns = [],
  data = [],
  rowKey = "id",
  renderRow,
  className = "card",
  tableClassName = "",
  getRowProps,
}) {
  return (
    <div className={className}>
      {title && <h2>{title}</h2>}

      <table className={tableClassName}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr
                key={
                  typeof rowKey === "function"
                    ? rowKey(item, index)
                    : item[rowKey] ?? index
                }
                {...(getRowProps ? getRowProps(item, index) : {})}
              >
                {renderRow ? (
                  renderRow(item, index)
                ) : (
                  columns.map((col) => (
                    <td key={col.key}>{item[col.key]}</td>
                  ))
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length || 1}>No hay datos disponibles.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}